import { render, staticRenderFns } from "./newsCard.vue?vue&type=template&id=134ced96&scoped=true&"
import script from "./newsCard.vue?vue&type=script&lang=js&"
export * from "./newsCard.vue?vue&type=script&lang=js&"
import style0 from "./newsCard.vue?vue&type=style&index=0&id=134ced96&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134ced96",
  null
  
)

export default component.exports